<template>
  <div>
    <!-- 头部导航 -->
    <div class="MdNav">
        <span class="MdNavLeft">
            <img :src="images.logoimg" alt="">
        </span>
        <span class="MdNavRight" @click="MdNavPopShow">
            <img :src="images.hanbaocaidan" alt="">
        </span>
    </div>
    <!-- 导航弹窗 -->
    <div class="MdNavPop" v-if="homePopShow"  >
      <Sidebar/>
      <div class="PopClose" @click="PopClose"></div>
    </div>
  </div>
</template>

<script>
import Sidebar from './cpmponents/Md/Sidebar/Sidebar.vue'
export default {
  components: { Sidebar },
  data () {
    return {
      images: {
        logoimg: require('@/views/navbar/img/companyName.png'),
        hanbaocaidan: require('@/views/navbar/img/hanbaocaidan.png')
      },
      MdNavPop: false
    }
  },
  computed: {
    homePopShow: {
      get () {
        return this.$store.state.homePopShow
      },
      set (val) {
        this.$store.commit('getHomePopShow', val)
      }

    }
  },
  methods: {
    MdNavPopShow () {
      if (this.$store.state.homePopShow === true) {
        this.$store.commit('getHomePopShow', false)
      } else {
        this.$store.commit('getHomePopShow', true)
      }
    },
    PopClose () {
      this.$store.commit('getHomePopShow', false)
    }
  }
}
</script>

<style lang="scss" scoped>
$md:72/192*2;
// 导航标题
.MdNav{
  position: fixed;
  top:0;
  height: 129px/$md;
  width: 750px/$md;
  background: #fff;
  z-index: 999;
  border-bottom: 1px/$md solid #c2c1c1;
  .MdNavLeft{
    float: left;
    width: 208px/$md;
    height: 48px/$md;
    margin-left: 50px/$md;
    margin-top: 40px/$md;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .MdNavRight{
    float: right;
    width: 40px/$md;
    height: 40px/$md;
    margin-right: 40px/$md;
    margin-top: 40px/$md;
    img{
      width: 100%;
      height: 100%;
    }
  }
}
// 导航菜单
.MdNavPop{
  position: fixed;
  top: 135px/$md;
  z-index: 991;
  width: 100%;
  height: 610px/$md*2;
  background: rgba($color: #000000, $alpha: 0.4);
  overflow-y:scroll;

}
.PopClose{
  position: absolute;
  top: 0;
  z-index: 993;
  width: 100%;
  height: 100%;
}
</style>
